<div fxLayout="column" style="padding:15px;">
    <mat-card>
        <mat-card-content fxLayout="column">
            <div fxLayout="row" fxFlex fxLayoutAlign="center center center">

                <div fxLayout="column" fxFlex="85">
                    <div fxLayout="row" style="padding:25px; font-size: 20px; margin-top: 20px; margin-bottom: 20px;">
                        Διαχείριση ολοκληρωμένων αναφορών
                    </div>


                    <!--            Search-->
                    <div fxLayout="row" fxLayoutGap="10px" style="padding:25px;" fxLayoutAlign="start center center">
                        <div>Αναζήτηση:</div>
                        <mat-form-field>
                            <input matInput placeholder="Αναζήτηση" (keypress)="search($event.target.value)">
                        </mat-form-field>
                    </div>
                    <!---->

                    <div fxLayout="row">
                        <mat-table [dataSource]="forms" matSort style="width:100%;">

                            <ng-container matColumnDef="id">
                                <mat-header-cell *matHeaderCellDef mat-sort-header fxLayoutAlign="start center center">
                                    Αναγνωριστικό εγγραφής
                                </mat-header-cell>
                                <mat-cell *matCellDef="let form"
                                          fxLayoutAlign="start center center"> {{form.id}} </mat-cell>
                            </ng-container>

                            <ng-container matColumnDef="title">
                                <mat-header-cell *matHeaderCellDef fxLayoutAlign="start center center"> Τίτλος Δήλωσης</mat-header-cell>
                                <mat-cell *matCellDef="let form"
                                          fxLayoutAlign="start center center"> {{form.title}} </mat-cell>
                            </ng-container>

                            <ng-container matColumnDef="published_at">
                                <mat-header-cell *matHeaderCellDef mat-sort-header fxLayoutAlign="start center center"> Ημ.
                                    δημοσίευσης
                                </mat-header-cell>
                                <mat-cell *matCellDef="let form"
                                          fxLayoutAlign="start center center"> {{form.published_at}} </mat-cell>
                            </ng-container>

                            <ng-container matColumnDef="date_completed">
                                <mat-header-cell *matHeaderCellDef mat-sort-header fxLayoutAlign="start center center">
                                    Συμπληρώθηκε
                                </mat-header-cell>
                                <mat-cell *matCellDef="let form"
                                          fxLayoutAlign="start center center"> {{form.date_completed}} </mat-cell>
                            </ng-container>

                            <ng-container matColumnDef="modified_by_displayName">
                                <mat-header-cell *matHeaderCellDef mat-sort-header fxLayoutAlign="start center center">
                                    Ενημερώθηκε από
                                </mat-header-cell>
                                <mat-cell *matCellDef="let form"
                                          fxLayoutAlign="start center center"> {{form.modified_by_displayName}} </mat-cell>
                            </ng-container>

                            <ng-container matColumnDef="modified_at">
                                <mat-header-cell *matHeaderCellDef mat-sort-header fxLayoutAlign="start center center">
                                    Ενημερώθηκε στις
                                </mat-header-cell>
                                <mat-cell *matCellDef="let form"
                                          fxLayoutAlign="start center center"> {{form.modified_at ? form.modified_at : '-'}} </mat-cell>
                            </ng-container>

                            <ng-container matColumnDef="isChecked">
                                <mat-header-cell *matHeaderCellDef mat-sort-header fxLayoutAlign="start center center">
                                    Ελέγχθηκε
                                </mat-header-cell>
                                <mat-cell *matCellDef="let form"
                                          fxLayoutAlign="start center center"> {{form.isChecked ? 'ΝΑΙ' : 'ΟΧΙ'}} </mat-cell>
                            </ng-container>

                            <ng-container matColumnDef="actions">
                                <mat-header-cell *matHeaderCellDef mat-sort-header fxLayoutAlign="start center center">
                                    Ενέργειες
                                </mat-header-cell>
                                <mat-cell *matCellDef="let form" fxLayoutAlign="start center center">
                                    <div fxLayout="row" fxLayoutAlign="center center center">
                                        <button matTooltip="Προβολή ιστορικού" mat-icon-button [disabled]="getHistoryCount(form) === 0"
                                                (click)="showHistory(form)">
                                            <mat-icon>remove_red_eye</mat-icon>
                                        </button>
                                        <button mat-icon-button (click)="exportToExcel(form)" matTooltip="Εξαγωγή σε Excel">
                                            <mat-icon class="icon">description</mat-icon>
                                        </button>

                                        <button *ngIf="!form.isChecked" mat-icon-button (click)="checkForm(form, 1)" matTooltip="Επιβεβαίωση">
                                            <mat-icon class="icon">check</mat-icon>
                                        </button>
                                        <button *ngIf="form.isChecked" mat-icon-button (click)="checkForm(form, 0)" matTooltip="Ακύρωση επιβεβαίωσης">
                                            <mat-icon class="icon">cancel</mat-icon>
                                        </button>
                                    </div>
                                </mat-cell>
                            </ng-container>


                            <mat-header-row *matHeaderRowDef="displayColumns; sticky: true"></mat-header-row>
                            <mat-row *matRowDef="let record; columns:displayColumns"></mat-row>
                        </mat-table>
                    </div>
                </div>
            </div>
            <div fxLayout="row" *ngIf="isLoading">
                <app-loading></app-loading>
            </div>
        </mat-card-content>
    </mat-card>


</div>
